import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Label = styled(FormControlLabel)(({ theme }) => ({
	position: 'relative',
	display: 'grid',
	gridTemplateColumns: '0fr 1fr',
	width: '100%',
	border: '1px solid grey',
	borderRadius: '5px',
	padding: '8px 0',
	marginTop: '10px',
	marginLeft: 0,
	marginRight: 0,

	'&:has(.Mui-checked)': {
		border: `1px solid ${theme.palette.primary.main}`,
	},
}));
